import React, {useState, useEffect, useRef} from "react";
import "../Styles/Main.css";

// import ProjIcon from "../Images/Icons/project.svg";


function Main({all_projects}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [Paused, setPaused] = useState(false);
  // const totalProjs = 6;
  // const anglePerProj = 60;

  const autoSpin = useRef(null)
  const resumeTimeout = useRef(null)

  const activeIndex = ((currentIndex % 6) + 6) % 6;
  const rotationAngle = currentIndex * 60 * -1;
  
  const carouselStyle = {
    transform: `rotateY(${rotationAngle}deg)`
  }
  
  const handlePrev = () => {
    setCurrentIndex(prev => prev - 1);
    handleUserInteraction()
  };
  const handleNext = () => {
    setCurrentIndex(prev => prev + 1);
    handleUserInteraction()
  }

  const startAutoSpin = () => {
    clearInterval(autoSpin.current)
    autoSpin.current = setInterval(() => {
      setCurrentIndex(prev => prev + 1)
    }, 2000)
  }

  const stopAutoSpin = () => {
    clearInterval(autoSpin.current)
    clearTimeout(resumeTimeout.current)
  }

  const handleUserInteraction = () => {
    stopAutoSpin()
    setPaused(true)

    resumeTimeout.current = setTimeout(() => {
      setPaused(false)
      startAutoSpin()
    }, 1500)
  }

  useEffect(() => {
    if (!Paused){
      startAutoSpin()
    }
    return ()  => stopAutoSpin()
  }, [Paused])

  const handleMouseEnter = () => {
    setPaused(true)
    stopAutoSpin()
  }

  const handleMouseLeave = () => {
    // if (resumeTimeout.current === null){
    //   setPaused(false)
    // }
    handleUserInteraction()
  }

  const lastSixProjects = all_projects.toReversed().slice(0,6);



  return (
    <div className="Main">
      <div>
        <h1 className="name">Riana Shahid</h1>
        <div className="text">
          Hi, I'm Riana! I use my technical skills and eye for design to craft
          code that makes an impact. I am a lifelong learner who is always eager
          to expand my knowledge and embark on new projects. <br />
          As a developer, I enjoy taking on complex challenges and coming up
          with forward-thinking solutions.
        </div>
      </div>
      <h2>
        {/* <img src={ProjIcon}/> */}
        Recent Projects
      </h2>
      {/* <div className="recent_projects">
        {lastSixProjects.map((project) => {
          return(
          <div className="project-card">
            <a href={project.siteLink}>
            <picture>
              <img
                className="proj-img"
                src={project.img}
                width={1150}
                height={700}
              ></img>
            </picture>
          </a>
          <div className="proj-info">
            <a href={project.siteLink}>
              <div className="proj-name">
                {project.title}
              </div>
            </a>
            <div className="proj-github">
              <a href={project.gitLink}>
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
          </div>
            
          </div>
        )})}
      </div> */}
      <div className="proj_carousel" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <div className="carousel-container">
          <div className="carousel" style={carouselStyle}>
            {/* map to create the carousel items */}
            {lastSixProjects.map((item, index) =>{
              const isActive = index === activeIndex;
              return (
                <div key={item.id} className={`carousel-item ${isActive ? 'active' : ''}`}>
                  <img src={item.img} alt={`${item.title} thumbnail`}/>
                  <div className="overlay">
                  <h3>{item.title}</h3>
                  <div>
                    <a href={item.siteLink} target="_blank" rel="noreferrer">Live Site</a>
                    <a href={item.gitLink} target="_blank" rel="noreferrer">Github</a>
                  </div>
                </div>
                </div>
              )
            })}
            
          </div>
        </div>
          <div className="proj_arrows">
            <button id="prev" onClick={handlePrev}>&larr;</button>
            <button id="next" onClick={handleNext}>&rarr;</button>
          </div>
      </div>
    </div>
  );
}

export default Main;
